"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowNotificationButton = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const Utils_1 = require("../../../../utils/Utils");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const bs_1 = require("react-icons/bs");
const CustomPagination_1 = require("../../../Common/CustomPagination");
const notification_api_1 = require("../../../../utils/api/notification/notification.api");
const UseCrudNotification_1 = require("../requestForm/UseCrudNotification");
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const ShowNotificationsModal_1 = __importDefault(require("../Modals/ShowNotificationsModal"));
const hook_1 = require("../../../../redux/hook");
const axios_1 = __importDefault(require("axios"));
const http_1 = require("../../../../utils/http");
const useWebSocket_1 = __importDefault(require("../../../../hooks/useWebSocket"));
const useRealtimeChannel_1 = __importDefault(require("../../../../hooks/useRealtimeChannel"));
const react_router_dom_1 = require("react-router-dom");
const DeleteNotificationButton = ({ id }) => {
    const onDelete = (0, UseCrudNotification_1.UseDeleteNotification)(id);
    return react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => onDelete() }, "Supprimer");
};
const ShowNotificationButton = ({ item }) => {
    const [showNotificationModal, setShowNotificationModal] = (0, react_1.useState)(false);
    const handleShowNotificationModal = () => {
        setShowNotificationModal(true);
    };
    const handleCloseNotificationModal = () => {
        setShowNotificationModal(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default.Item, { onClick: handleShowNotificationModal }, "Voir les d\u00E9tails"),
        react_1.default.createElement(ShowNotificationsModal_1.default, { show: showNotificationModal, handleClose: handleCloseNotificationModal, item: item })));
};
exports.ShowNotificationButton = ShowNotificationButton;
const MyNotificationsTable = ({ search, selectedCategory, dates, }) => {
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data = { data: [], count: 0 }, isLoading } = (0, notification_api_1.useGetNotificationsByStaffMemberIdQuery)({ user_id: user === null || user === void 0 ? void 0 : user.user_id });
    const [trigger] = (0, notification_api_1.useLazyGetNotificationsByStaffMemberIdQuery)();
    const [triggerNotificationById] = (0, notification_api_1.useLazyNotificationByIdQuery)();
    const socket = (0, useWebSocket_1.default)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const openPivot = searchParams.get("open-pivot");
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    const [fromAwayNotification, setFromAwayNotification] = (0, react_1.useState)([]);
    const handleCloseModal = () => setOpenModal(false);
    const [triggerAllNotifications] = (0, notification_api_1.useLazyGetNotificationsByStaffMemberIdAllQuery)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    console.log('openPivot', openPivot);
    (0, useRealtimeChannel_1.default)({
        socket,
        channel: "notifications",
        event: "new.notification",
        onMessage: (data) => {
            console.log("🟢 Nouvelle notification reçue : ", data);
            trigger({ user_id: user === null || user === void 0 ? void 0 : user.user_id });
        },
    });
    const filteredData = data.data.filter((item) => {
        var _a, _b, _c, _d, _e;
        const matchSearch = ((_a = item.content) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase())) ||
            ((_b = item.segment) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(search.toLowerCase())) ||
            ((_c = item.scheduled_datetime) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(search.toLowerCase()));
        const matchCategory = selectedCategory
            ? ((_e = (_d = item.categorie) === null || _d === void 0 ? void 0 : _d.name) === null || _e === void 0 ? void 0 : _e.toLowerCase()) ===
                selectedCategory.toLowerCase()
            : true;
        const matchDate = dates.startDate && dates.endDate
            ? (() => {
                const scheduledDate = new Date(item.scheduled_datetime);
                return (scheduledDate >= dates.startDate &&
                    scheduledDate <= dates.endDate);
            })()
            : true;
        return matchSearch && matchCategory && matchDate;
    });
    const paginatedData = filteredData.slice((page - 1) * perPage, page * perPage);
    const editStaffNotificationReadStatus = (id) => {
        const request = axios_1.default.get(`${http_1.ApiBaseUrl}setMyNotificationIsRead/${id}`);
        request.then((response) => {
            console.log(response.data);
            trigger({ user_id: user === null || user === void 0 ? void 0 : user.user_id });
        }).catch((error) => {
            console.log('error', error);
        });
    };
    (0, react_1.useEffect)(() => {
        console.log("openPivot in useEffect => ", openPivot);
        const fetchNotification = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (!openPivot)
                return;
            const notificationId = parseInt(openPivot);
            try {
                // 🔹 1. Tente de trouver dans les notifs non paginées
                const res = yield triggerAllNotifications({ user_id: user === null || user === void 0 ? void 0 : user.user_id }).unwrap();
                const list = Array.isArray(res) ? res : (_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : [];
                let notification = list.find((item) => (item === null || item === void 0 ? void 0 : item.id) === notificationId);
                console.log("notification with openPivot", notification);
                if (notification) {
                    setOpenModal(true);
                    setFromAwayNotification(notification);
                    editStaffNotificationReadStatus((_b = notification === null || notification === void 0 ? void 0 : notification.pivot) === null || _b === void 0 ? void 0 : _b.id);
                    navigate("/admin/mes-notifications/recues", { replace: true });
                }
            }
            catch (error) {
                console.error("Erreur pendant la récupération de la notification:", error);
            }
        });
        fetchNotification();
    }, [openPivot]);
    const titreFormatter = (cell, row) => {
        var _a;
        return (react_1.default.createElement("div", { className: "formatter__wrapper relative-for-absolute-child" },
            react_1.default.createElement("div", { className: `d-flex gap-3 ${(row === null || row === void 0 ? void 0 : row.media_type) !== "image"
                    ? "flex-column align-items-start"
                    : "flex-row align-items-center"}` },
                (row === null || row === void 0 ? void 0 : row.media) && (row === null || row === void 0 ? void 0 : row.media_type) === "image" && (react_1.default.createElement("div", { className: "image__wrapper" },
                    react_1.default.createElement(react_medium_image_zoom_1.default, null,
                        react_1.default.createElement("img", { src: (0, Utils_1.getAvatar)(row === null || row === void 0 ? void 0 : row.media), alt: "illustration", className: "custom-image-table", "data-zoomable": true })))),
                (row === null || row === void 0 ? void 0 : row.media) && (row === null || row === void 0 ? void 0 : row.media_type) === "video" && (react_1.default.createElement("div", { className: "image__wrapper" },
                    react_1.default.createElement(react_medium_image_zoom_1.default, null,
                        react_1.default.createElement("video", { src: (0, Utils_1.getAvatar)(row === null || row === void 0 ? void 0 : row.media), controls: true, style: {
                                width: "200px",
                                height: "120px",
                                borderRadius: "4px",
                                objectFit: "cover",
                            } })))),
                (row === null || row === void 0 ? void 0 : row.media) && (row === null || row === void 0 ? void 0 : row.media_type) === "audio" && (react_1.default.createElement("div", { className: "image__wrapper" },
                    react_1.default.createElement(react_medium_image_zoom_1.default, null,
                        react_1.default.createElement("audio", { src: row === null || row === void 0 ? void 0 : row.media, controls: true, style: { width: "230px" } })))),
                (row === null || row === void 0 ? void 0 : row.content) && (react_1.default.createElement("div", { className: "d-flex flex-column gap-1" },
                    react_1.default.createElement("p", { className: "m-0", dangerouslySetInnerHTML: (0, Utils_1.createMarkup)((0, Utils_1.truncateString)(row === null || row === void 0 ? void 0 : row.content, 100)) }),
                    (row === null || row === void 0 ? void 0 : row.media_type) === "image" && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-1" },
                        react_1.default.createElement("img", { src: "/images/icons/type.svg", alt: "illustration" }),
                        react_1.default.createElement("span", null, "Photo"))),
                    ((row === null || row === void 0 ? void 0 : row.media_type) === "video" ||
                        (row === null || row === void 0 ? void 0 : row.media_type) === "audio") && (react_1.default.createElement("div", { className: "d-flex align-items-center gap-1" },
                        react_1.default.createElement("img", { src: "/images/icons/type-2.svg", alt: "illustration" }),
                        react_1.default.createElement("span", null, "Vid\u00E9o / Audio")))))),
            ((_a = row === null || row === void 0 ? void 0 : row.pivot) === null || _a === void 0 ? void 0 : _a.is_read) === 0 && (react_1.default.createElement("div", { className: "custon-date-indicator absolute" }))));
    };
    const formatPublicationDate = (datetime) => {
        const moment = require("moment");
        moment.locale("fr");
        if (!datetime)
            return "";
        const now = moment();
        const date = moment(datetime);
        if (!date.isValid())
            return "";
        if (date.isSame(now, "day")) {
            return `Aujourd’hui - ${date.format("HH:mm")}`;
        }
        return ((0, Utils_1.capitalize)(date.format("dddd D MMMM - HH:mm")));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "actionformatter__wrapper" },
            react_1.default.createElement(Dropdown_1.default, null,
                react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-basic" },
                    react_1.default.createElement(bs_1.BsThreeDots, null)),
                react_1.default.createElement(Dropdown_1.default.Menu, null,
                    react_1.default.createElement(Dropdown_1.default.Item, { onClick: () => {
                            var _a, _b;
                            ((_a = row === null || row === void 0 ? void 0 : row.pivot) === null || _a === void 0 ? void 0 : _a.is_read) === 0 && (editStaffNotificationReadStatus((_b = row === null || row === void 0 ? void 0 : row.pivot) === null || _b === void 0 ? void 0 : _b.id));
                        } },
                        react_1.default.createElement(exports.ShowNotificationButton, { item: row }))))));
    };
    const columns = [
        {
            dataField: "titre",
            text: "Message",
            formatter: titreFormatter,
            headerStyle: () => {
                return {
                    width: "260px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "scheduled_datetime",
            text: "Date de publication",
            formatter: (cell, row) => {
                const dateToFormat = row.is_scheduled === 1
                    ? row.scheduled_datetime
                    : row.created_at;
                return formatPublicationDate(dateToFormat);
            },
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "categorie.name",
            text: "Type",
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData === null || filteredData === void 0 ? void 0 : filteredData.length, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage })))),
            react_1.default.createElement(ShowNotificationsModal_1.default, { show: openModal, handleClose: handleCloseModal, item: fromAwayNotification })))));
};
exports.default = MyNotificationsTable;
